import { UI } from "@wwimmo/ui";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { ColorStyle } from "src/utils/Colors";
import { observer } from "mobx-react";
import * as Sentry from "@sentry/react";
import { NetworkConfig } from "src/network/NetworkConfig";
import { IFile } from "src/types";
import styles from "src/components/fileSelector/FileSelector.module.css";

interface FileSelectorItemModalProps {
    file?: IFile;
    isDisplayed: boolean;
    toggleDisplayFileModal: any;
}

const FileSelectorItemModalBase = (props: FileSelectorItemModalProps) => {
    const { t } = useTranslation();

    const { file, isDisplayed, toggleDisplayFileModal } = props;

    const [isFileLoading, setIsFileLoading] = useState<boolean>(true);
    const [hadErrorLoadingFile, setHadErrorLoadingFile] = useState<boolean>(false);

    const onFileLoad = useCallback(() => {
        setIsFileLoading(false);
    }, []);

    const onImageError = useCallback(() => {
        setHadErrorLoadingFile(true);
        setIsFileLoading(false);
    }, []);

    const fileSource = file?.base64String
        ? `data:${file?.mimetype};base64,${file?.base64String}`
        : `${NetworkConfig.openThumbnailUrl}${file?.fileId}`;

    return (
        <UI.Modal
            size="lg"
            show={isDisplayed}
            onClose={toggleDisplayFileModal}
            centered={true}
            className={styles.FileModal}
        >
            <img src={fileSource} onLoad={onFileLoad} onError={onImageError} alt="" />

            {isFileLoading && file?.fileId ? <UI.RotatingSpinner noLogo={true} size={25} /> : undefined}

            {hadErrorLoadingFile ? (
                <div className={styles.FileLoadingErrorContainer}>
                    <UI.Icon icon={UI.SVGIcon.CloseCircle} color={ColorStyle("danger")} size={40} className="mb-1" />
                    <span>{t("screens.tickets.form.notification.image_loading_error")}</span>
                </div>
            ) : undefined}
        </UI.Modal>
    );
};

export const FileSelectorItemModal = Sentry.withProfiler(observer(FileSelectorItemModalBase));
